import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Constants } from '../../common/constants';
import { FormComponentBase } from '../../common/form-component-base';
import { Global } from '../../common/global';
import { StaticDataService } from '../../services/api/static-data.service';
import { SessionService } from '../../services/session/session.service';
import { TaxEIncomeModel } from './tax-e-income-model';
var TaxEIncomeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TaxEIncomeComponent, _super);
    function TaxEIncomeComponent(staticDataService, changeDetectorRef, sessionService) {
        var _this = _super.call(this) || this;
        _this.staticDataService = staticDataService;
        _this.changeDetectorRef = changeDetectorRef;
        _this.sessionService = sessionService;
        _this.warningDialogVisible = false;
        _this.linkWorksElsewhere = 'https://skat.dk/skat.aspx?oid=2234073&chk=217351';
        _this.childIsDirty = Array(6).fill(false);
        _this.editModeChange.subscribe(function (value) {
            if (value && _this.model) {
                _this.previousImcomeTypeId = _this.model.IncomeTypeId;
            }
        });
        return _this;
    }
    Object.defineProperty(TaxEIncomeComponent.prototype, "model", {
        get: function () {
            if (!this.modelValue) {
                this.modelValue = {};
            }
            return this.modelValue;
        },
        set: function (value) {
            this.modelValue = value;
            if (value) {
                this.previousImcomeTypeId = value.IncomeTypeId;
            }
            this.childIsDirty = Array(6).fill(false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaxEIncomeComponent.prototype, "admin", {
        get: function () {
            if (Global.SESSION.CurrentRole.Key === 'FullAdmin' ||
                Global.SESSION.CurrentRole.Key === 'SalaryAdmin' ||
                this.sessionService.currentState === 'tabs.selfservice.general') {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaxEIncomeComponent.prototype, "iscompanyTemplatesTab", {
        get: function () {
            return this.sessionService.currentState === 'tabs.company.configuration.hiringstatus';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaxEIncomeComponent.prototype, "isDanishCompany", {
        get: function () {
            return Global.COMPANY && Global.COMPANY.CountryId === Constants.DENMARK_COUNTRY_ID;
        },
        enumerable: true,
        configurable: true
    });
    TaxEIncomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.staticDataService.IncomeType.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
            _this.incomeTypes = data;
            _this.changeDetectorRef.markForCheck();
        });
    };
    TaxEIncomeComponent.prototype.onWarningDialogAction = function (action) {
        if (action === 'Continue') {
            this.previousImcomeTypeId = this.model.IncomeTypeId;
            this.onChange();
        }
        else {
            this.model.IncomeTypeId = this.previousImcomeTypeId;
        }
    };
    TaxEIncomeComponent.prototype.onIncomeTypeChanged = function () {
        if (this.model.IncomeTypeId === 5) {
            this.warningDialogVisible = true;
            this.changeDetectorRef.markForCheck();
        }
        else {
            this.onChange();
        }
    };
    return TaxEIncomeComponent;
}(FormComponentBase));
export { TaxEIncomeComponent };
